import { defineComponent as _defineComponent } from 'vue'
import { PaymentMethodDetails } from '@/@types/billing/subscription/PaymentMethodDetails';
import PaymentMethod from '@/components/billing/PaymentMethod.vue';
import apiService from '@/services/ApiService';
import billingService from '@/services/BillingService';
import { Loading } from 'element-ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePaymentMethod',
  props: {
    payment: null,
    subscriptionId: null
  },
  setup(__props: any) {

const props = __props as { payment: PaymentMethodDetails; subscriptionId: string }



const changePaymentMethod = async () => {
  const loader = Loading.service({ lock: true });

  try {
    const transactionRes = await apiService.billing.updatePaymentMethod(props.subscriptionId);
    const transactionId = transactionRes.data.transactionId;

    billingService.redirectToCheckout(transactionId);
  } catch (err) {
    apiService.handleResponseError(err);
  }

  loader.close();
  loader.$destroy();
};

return { __sfc: true,props, changePaymentMethod, PaymentMethod }
}

})